import { CSSProperties, FC, ReactNode } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '~/icons';
import { modalHeaderStyles } from './styles';

interface ModalHeaderProps {
  onClose: () => void;
  title: string[] | ReactNode;
  style?: CSSProperties;
}

const ModalHeader: FC<ModalHeaderProps> = ({ onClose, title, style }) => {
  return (
    <Box sx={{ ...modalHeaderStyles, ...style }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {Array.isArray(title)
          ? title.map((el, i) => (
              <Typography
                key={el}
                variant={i ? 'bodyLarge' : 'bodyXl'}
                whiteSpace="pre-wrap"
                sx={{ wordBreak: 'break-word' }}
              >
                {el}
              </Typography>
            ))
          : title}
      </Box>
      <IconButton onClick={onClose} sx={{ alignSelf: 'start' }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
